import { HTMLProps } from 'react';
import classNames from 'classnames';

import { SpinnerIcon } from '../../assets';

import styles from './Spinner.module.scss';

export interface ISpinnerProps extends React.DetailedHTMLProps<HTMLProps<SVGSVGElement>, SVGSVGElement> {
    color?: 'primary' | 'success' | 'error' | 'warning' | 'black' | 'white' | 'inherit';
    size?: number;
    fullScreen?: boolean;
}

export const Spinner: React.FC<ISpinnerProps> = ({ fullScreen, className, color = 'primary', size = 24, ...props }) => {
    const SpinnerElement = (
        <SpinnerIcon
            className={classNames(styles[`color-${color}`], { [styles['spinner-full-screen']]: fullScreen }, className)}
            width={size}
            height={size}
            {...props}
        />
    );

    if (fullScreen) {
        return <div className={classNames(styles['wrapper-full-screen'])}>{SpinnerElement}</div>;
    }

    return SpinnerElement;
};
